import { makeAutoObservable } from 'mobx';

class LoadingStore {
    private _count = 0;
    loading = false;

    constructor() {
        makeAutoObservable(this);
    }

    show() {
        this._count++;
        this.loading = true;
    }

    hide() {
        this._count = Math.max(0, this._count - 1);
        if (this._count === 0) {
            this.loading = false;
        }
    }

    setLoading(value: boolean) {
        if (value) {
            this.show();
        } else {
            this.hide();
        }
    }
}

const loadingStore = new LoadingStore();
export default loadingStore;
